import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=26a4e4a5&"
import script from "./MyRequests.vue?vue&type=script&lang=js&"
export * from "./MyRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports